import React from "react";

export default function Contact() {
  return (
    <div style={{ marginTop: "7rem" }}>
      <div className="container">
        <div className="about">
          <div className="card border-primary mb-3" style={{ width: "auto" }}>
            <div className="card-body">
              <h5 className="card-title text-primary">CONTACT DETAILS</h5>
              <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
              <div>
                {/* <!--ADDRESS--> */}
                <div className="contact" id="con_details">
                  <div className="card">
                    <div>
                      <p>
                        <span>
                          THE CONFERENCE CHAIR (ETCAN’21),
                          <br />
                          KONGUNADU COLLEGE OF ENGINEERING AND TECHNOLOGY,
                          <br />
                        </span>
                        Namakkal-Trichy Main Road,
                        <br />
                        Thottiam, Trichy (Dt)-621 215,
                        <br />
                        Tamilnadu.
                        <br />
                      </p>

                      <div id="table">
                        <table className="table">
                          <tbody className="table-borderless">
                            <tr>
                              <td>Mobile</td>
                              <td>+91- 8012510197, +91- 8012505008</td>
                            </tr>
                            <tr>
                              <td>E-Mail ID</td>
                              <td style={{ color: "blue" }}>
                                etcan21@kongunadu.ac.in
                              </td>
                            </tr>
                            <tr>
                              <td>Website</td>
                              <td>
                                <a
                                  style={{ color: "blue" }}
                                  href="www.kongunadu.ac.in"
                                >
                                  www.kongunadu.ac.in
                                </a>
                              </td>
                            </tr>
                            <tr></tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {/* <!--/ADDRESS--> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
